import React from 'react';

import { useVerificationRequestProcessing } from 'src/hooks/verificationRequest';

import {
  VerificationRequestFormContext,
  VerificationRequestFormContextValue,
} from './VerificationRequestFormContext';

export const VerificationRequestFormProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [isEmployeeInfoLoading, setIsEmployeeInfoLoading] = React.useState(false);
  const [isEmployeeExists, setIsEmployeeExists] = React.useState(false);
  const [isEmployeeFrozen, setIsEmployeeFrozen] = React.useState(false);
  const [isEmployersInfoLoading, setIsEmployersInfoLoading] = React.useState(false);
  const [isEmployersHavePayrollsInfo, setIsEmployersHavePayrollsInfo] = React.useState(false);
  const [isPermissiblePurposesLoading, setIsPermissiblePurposesLoading] = React.useState(false);
  const [isTotalChargeLoading, setIsTotalChargeLoading] = React.useState(false);

  const { startSubmitting, stopSubmitting } = useVerificationRequestProcessing();

  const resetData = React.useCallback(() => {
    setIsEmployeeExists(false);
    setIsEmployeeFrozen(false);
  }, []);

  const isFormInfoLoading = React.useMemo(() => {
    return (
      isEmployeeInfoLoading ||
      isEmployersInfoLoading ||
      isPermissiblePurposesLoading ||
      isTotalChargeLoading
    );
  }, [
    isEmployeeInfoLoading,
    isEmployersInfoLoading,
    isPermissiblePurposesLoading,
    isTotalChargeLoading,
  ]);

  const contextValue: VerificationRequestFormContextValue = React.useMemo(
    () => ({
      isEmployeeInfoLoading,
      setIsEmployeeInfoLoading,
      isEmployeeExists,
      setIsEmployeeExists,
      isEmployeeFrozen,
      setIsEmployeeFrozen,
      isEmployersInfoLoading,
      setIsEmployersInfoLoading,
      isEmployersHavePayrollsInfo,
      setIsEmployersHavePayrollsInfo,
      isPermissiblePurposesLoading,
      setIsPermissiblePurposesLoading,
      isTotalChargeLoading,
      setIsTotalChargeLoading,
      isFormInfoLoading,
      resetData,
      startSubmitting,
      stopSubmitting,
    }),
    [
      isEmployeeInfoLoading,
      isEmployeeExists,
      isEmployeeFrozen,
      isEmployersInfoLoading,
      isEmployersHavePayrollsInfo,
      isPermissiblePurposesLoading,
      isTotalChargeLoading,
      isFormInfoLoading,
      resetData,
      startSubmitting,
      stopSubmitting,
    ],
  );

  return (
    <VerificationRequestFormContext value={contextValue}>{children}</VerificationRequestFormContext>
  );
};
